export const YELLOW = '#ffd200'



// WEBPACK FOOTER //
// ./src/ui.js